import { useParams } from 'react-router';
import { type RouteParams } from '../../../util/routes';
import { useGetMap as useGetMapRequest } from '../../../service/requests';
import { type Response, isSuccess, success } from '../../../service/response';
import { type Map } from '../../../util/types';
export const useGetMap = (): Response<Map, Error> => {
  const { mapId } = useParams<RouteParams<'viewMap'>>();
  const resp = useGetMapRequest(mapId!);

  if (isSuccess(resp)) {
    return success({ ...resp.data[0] });
  }

  return resp;
};
